import { print } from 'graphql';
import { GET_FILTERED_PRODUCTS } from '../categoryGQL';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_API_PRODUCT_URL!;

// Helper: Add Authorization header if token exists
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : '',
  };
};

// Fetch filtered products using GraphQL POST request
export async function fetchFilteredProducts(
  minPrice: number,
  maxPrice: number,
  categoryId: string,
  inStock: boolean,
  limit: number,
  offset: number
): Promise<any[]> {
  const response = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(), // ✅ Add token here
    },
    body: JSON.stringify({
      query: print(GET_FILTERED_PRODUCTS),
      variables: { minPrice, maxPrice, categoryId, inStock, limit, offset },
    }),
  });

  const { data, errors } = await response.json();
  if (errors?.length) {
    throw new Error(errors[0].message);
  }

  // Map edges to product nodes
  return data.getProducts.edges.map((edge: any) => edge.node);
}
